import { render, staticRenderFns } from "./quesbank-manage.vue?vue&type=template&id=28d2c6aa&scoped=true"
import script from "./quesbank-manage.vue?vue&type=script&lang=js"
export * from "./quesbank-manage.vue?vue&type=script&lang=js"
import style0 from "./quesbank-manage.vue?vue&type=style&index=0&id=28d2c6aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d2c6aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d2c6aa')) {
      api.createRecord('28d2c6aa', component.options)
    } else {
      api.reload('28d2c6aa', component.options)
    }
    module.hot.accept("./quesbank-manage.vue?vue&type=template&id=28d2c6aa&scoped=true", function () {
      api.rerender('28d2c6aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/research/quesbank-manage.vue"
export default component.exports